import $ from 'jquery';
import LP from './0-lp';
import {is_function} from '../../Helpers/js/simple.functions';

// ----------- //
// UI Class    //
// ----------- //
const UI = window['UI'] ??= {

    // --------------
    // Setup Methods
    // --------------

    setupButtons: function (selector) {
        $(selector).each(function (index, elem) {
            $(elem).button();
        });
    },

    setupProgressBars: function (selector) {
        selector.progressbar({
            create: function () {
                $(this).progressbar({value: parseInt($(this).attr('value'))});
            }
        });
    },

    setupSpinbox: function (item, min, max, cur, incr, floating, onChange, canBeEmpty, canBeAnyText, useAutoCorrection, canBePercent) {
        var parent = $(item).parent();
        return UI.Spinbox.setup(min, max, cur, incr, floating, $(item), $('.spinUp', parent), $('.spinDown', parent), onChange, canBeEmpty, canBeAnyText, useAutoCorrection, canBePercent);
    },

    showMsgBox: function (text, state, onSubmit, onReject) {
        UI.MsgBox.show(text, state, onSubmit, onReject);
    },

    showPopup: function (trigger, popup) {
        if (!popup.isVisible()) {
            popup.css('left', (trigger.position().left + 20) + 'px');
            popup.css('top', (trigger.position().top - 130) + 'px');
            popup.show('fast');
        }
    },

    hidePopup: function (trigger, popup) {
        if (popup.isVisible()) popup.hide('fast');
    },

    suppressEnter: function (form, disablePassword) {
        $('input', form).each(function (index, input) {
            input = $(input);
            if (input.attr('type') == 'hidden') return;
            if (!input.attr('tabindex')) return;
            input.keypress(function (event) {
                if (event.keyCode == 13) {
                    if (disablePassword && this.type == 'password') return true;
                    if (UI.focusNext($(this))) return false;
                    return true;
                }
                return true;
            });
        });
    },

    focusNext: function (node) {
        if (!node.attr('tabindex')) return false;

        var nextIndex = parseInt(node.attr('tabindex')) + 1;
        var nextNode = null;

        do {
            nextNode = $('*[tabindex="' + (nextIndex++) + '"]');
        }
        while (nextNode.length == 0 && nextIndex < 999);

        if (nextNode) {
            nextNode.focus();
            return true;
        }
        return false;
    },

    // --------------
    // Event Methods
    // --------------
    events: new Array(), // Event-Handlers

    onInitEvent: function (callback) {
        UI.addListener('onInit', '', callback, true);
    },
    onShowEvent: function (callback) {
        UI.addListener('onShow', '', callback, false);
    },
    onHideEvent: function (callback) {
        UI.addListener('onHide', '', callback, false);
    },
    onChangeEvent: function (element, callback) {
        UI.addListener('onChange', element, callback, false);
    },
    onSubmitEvent: function (element, callback) {
        UI.addListener('onSubmit', element, callback, true);
    },

    addListener: function (event, eventListener, eventFunc, callOnceOnly) {
        if (!event || event == '') event = '*';
        UI.events.push({event: event, listener: eventListener, func: eventFunc, onlyOnce: callOnceOnly});
    },

    triggerEvent: function (event, source) {
        if (!source || source == '') source = '*';
        var numEvents = UI.events.length;

        for (var i = 0; i < numEvents; i++) {
            if (i in UI.events && is_function(UI.events[i].func)) {
                // Match event

                if ((source == '*' || UI.events[i].listener == '' || UI.events[i].listener == source) && (UI.events[i].event == '*' || UI.events[i].event == event)) {
                    // Do event function
                    UI.events[i].func();
                    // Removes used events
                    if (UI.events[i].onlyOnce) delete UI.events[i];
                }
            }
        }
    },

    // ---------------------
    // Misc Methods
    // ---------------------
    getLanguage: function () {
        return LP.getLanguage();
    },

    mouseIsOverWorkaround: function (what) {
        var temp = what.parent().find(':hover');
        return temp.length > 0 && temp[0] == what[0];
    }

};

export default UI;
